import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import { Button, Stack, Typography } from "@mui/material";

import React from "react";
import { useTranslation } from "react-i18next";

export type SelectedFileViewProps = {
  selectedFile: File;
  disabled: boolean;
  acceptedFormats?: string;
  onFileUpload: (files: File[]) => Promise<void>;
  setCallFn: (value: boolean) => void;
};

export const SelectedFileView: React.FC<SelectedFileViewProps> = ({
  selectedFile,
  disabled,
  acceptedFormats,
  onFileUpload,
  setCallFn,
}) => {
  const { t } = useTranslation();
  return (
    <Stack spacing={1} alignItems="center" sx={{ maxWidth: "80%", textAlign: "center" }}>
      <FileUploadOutlinedIcon color="primary" />
      <Typography variant="body2" color="primary" sx={{ wordBreak: "break-word" }}>
        {selectedFile.name}
      </Typography>
      <Button variant="text" component="label" color="primary" disabled={disabled} size="small">
        {t("upload.selectFromComputer")}
        <input
          type="file"
          id="file"
          style={{ display: "none" }}
          disabled={disabled}
          accept={acceptedFormats}
          onChange={async (event) => {
            if (disabled) return;
            const files = event.target.files;
            if (files && files.length > 0) {
              setCallFn(true);
              await onFileUpload(Array.from(files));
              setCallFn(false);
            }
          }}
        />
      </Button>
    </Stack>
  );
};
